module.exports = __webpack_public_path__ + "img/footer.a35b9838.png";